import { memo } from 'react'
import { useField, UseFieldConfig } from 'react-final-form'
import { useGetCargoSizeQuery } from 'api/cargoSize'
import CargoSizeControl from 'components/CargoSizeControl'
import { checkFieldError } from 'shared/helpers/form'

interface FieldCargoSizeProps {
  name: string
  testId?: string
  validate?: UseFieldConfig<string>['validate']
}

export const FieldCargoSize = memo(({ name, validate }: FieldCargoSizeProps) => {
  const { data: cargoSize } = useGetCargoSizeQuery()
  const { input, meta } = useField<string>(name, {
    validate,
    parse: (value) => value || ''
  })

  return (
    <CargoSizeControl
      cargoSize={cargoSize}
      invalid={Boolean(checkFieldError(meta))}
      onChange={input.onChange}
      value={input.value}
    />
  )
})

export default FieldCargoSize
